import { QUERY_KEYS } from '../../../type';
import { useQuery } from '@umijs/max';
import { isNil } from 'lodash';
import { useCallback, useEffect, useMemo } from 'react';
import * as API from '../services';
import { useWorkflowStore } from '../store';
import { useWorkflowTemplate } from './use-workflow-template';
import { ApiFilled } from '@ant-design/icons';

const panelId = 'workflow-node-panel-width';

const ModeStatusMap = {
  1: 'published',
};

// todo: 改名 usePanelWidth
export const useWorkflow = () => {
  const workflowStore = useWorkflowStore();

  const panelWidth = useMemo(() => {
    return localStorage.getItem(panelId)
      ? parseFloat(localStorage.getItem(panelId)!)
      : 446;
  }, []);

  const setPanelWidth = useCallback(
    (width: number) => {
      localStorage.setItem(panelId, `${width}`);
      workflowStore.setState({ panelWidth: width });
    },
    [workflowStore],
  );
  return { setPanelWidth, panelWidth };
};

export const useWorkflowInit = (
  {
    template_code,
    readonly,
  }: {
    readonly: boolean;
    template_code?: string;
  } = { readonly: false },
) => {
  const workflowStore = useWorkflowStore();

  const {
    data,
    isLoading: loading,
  } = useQuery({
    queryKey: [
      QUERY_KEYS.WORKFLOW_CONFIG,
      API.getFullWorkflow.queryKey,
      template_code,
    ],
    queryFn: async () => {
      if (!template_code) return;
      const res = await API.getFullWorkflow(template_code as string);
      return res;
    },
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!data) {
      workflowStore.setState({
        mode: 'create',
      });
    } else {
      workflowStore.setState({
        appId: template_code,
        notInitialWorkflow: true,
        readonly,
        template_code: template_code,
        mode: 'edit',
      });
    }
  }, [workflowStore, template_code, readonly, data]);

  const { nodes: nodesTemplate, edges: edgesTemplate } = useWorkflowTemplate();

  const isInit = data?.nodes?.length === 0 || data?.edges?.length === 0;

  return {
    data: {
      nodes: isInit ? nodesTemplate : data?.nodes,
      edges: isInit ? edgesTemplate : data?.edges,
    },
    isLoading: loading,
  };
};

export const useWorkflowReadOnly = () => {
  const workflowStore = useWorkflowStore();

  const nodesReadOnly = workflowStore.getState().readonly;

  const getNodesReadOnly = useCallback(() => {
    return workflowStore.getState().readonly;
  }, []);
  return {
    nodesReadOnly: nodesReadOnly,
    getNodesReadOnly: getNodesReadOnly,
  };
};

// export const useWorkflowReadOnly = () => {
//   const getWorkflowReadOnly = useCallback(() => {
//     return false;
//   }, []);
//
//   return {
//     workflowReadOnly: false,
//     getWorkflowReadOnly,
//   };
// };
